import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Chip,
  Box,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from "../../JobBatch.module.css";
import PdfIcon from "../../../../../shared/assets/icons/PdfIcon.png";

const NotAccepted = ({ isNotAccepted, matchingJobs }) => {
  const [expandedBatch, setExpandedBatch] = React.useState(null);

  const handleAccordionToggle = (batchTitle) => (event) => {
    event.stopPropagation();
    setExpandedBatch((prev) => (prev === batchTitle ? null : batchTitle));
  };

  // Helper function to calculate date range
  const calculateDateRange = (jobs) => {
    if (!jobs || jobs.length === 0) return "No Jobs Available";
    const startDates = jobs.map((job) => new Date(job.jobStartingDate));
    const endDates = jobs.map((job) => new Date(job.jobCompletionDate));
    const startDate = new Date(Math.min(...startDates)).toLocaleDateString();
    const endDate = new Date(Math.max(...endDates)).toLocaleDateString();
    return `${startDate} - ${endDate}`;
  };

  return (
    <Grid className={`${styles.scrollableContainer}`}>
      {isNotAccepted.length === 0 ? (
        <Typography
          className={`${styles.noJobsBox} ${styles.noJobsText}`}
          variant="h6"
          align="center"
        >
          No Batch of Jobs Available
        </Typography>
      ) : (
        isNotAccepted?.map((batch, index) => (
          <Grid item xs={12} md={12} key={index} my={1} mx={2}>
            <Accordion expanded={expandedBatch === batch.batchTitle}>
              <AccordionSummary
                expandIcon={
                  <IconButton onClick={handleAccordionToggle(batch.batchTitle)}>
                    <ExpandMoreIcon />
                  </IconButton>
                }
                aria-controls={`panel-${index}-content`}
                id={`panel-${index}-header`}
              >
                <div className="flex items-center justify-between p-4 rounded-lg bg-white w-full mx-auto">
                  {/* Section 1: Batch Title */}
                  <div className="flex">
                    <h1 className={`${styles.batchTitle}`}>
                      {batch.batchTitle}
                    </h1>
                  </div>

                  {/* Section 2: Other Details */}
                  <div className="flex items-center gap-6">
                    {/* Date Range */}
                    <Chip
                      label={calculateDateRange(matchingJobs)}
                      className={styles.chip}
                    />
                  </div>
                </div>
              </AccordionSummary>

              <AccordionDetails className={styles.accordionDetails}>
                {/* Render Job Details Table */}
                <Box className={`${styles.scrollableBox}`}>
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead>
                        <TableRow className={styles.tableHeader}>
                          <TableCell className={styles.tableCell}>
                            ADDRESS
                          </TableCell>
                          <TableCell className={styles.tableCell}>
                            STORE MANAGER
                          </TableCell>

                          <TableCell className={styles.tableCell}>
                            JOB DATE
                          </TableCell>
                          <TableCell className={styles.tableCell}>
                            JOB PAY
                          </TableCell>

                          <TableCell className={styles.tableCell}>
                            RECCE REPORT
                          </TableCell>
                          <TableCell className={styles.tableCell}>
                            ACTION
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {batch?.jobs?.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell className={styles.tableCell}>
                              <div className={styles.sharedTextStyle}>
                                {row.address1}
                              </div>
                              <div className={styles.address2}>
                                {row.address2}
                              </div>
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              <div className={styles.sharedTextStyle}>
                                {row.storeOwnerName}
                              </div>
                              <div className={styles.storeManagerContact}>
                                {row.storeOwnerPhoneNumber}
                              </div>
                            </TableCell>

                            <TableCell className={styles.tableCell}>
                              <div className={styles.sharedTextStyle}>
                                {row.jobDate}
                              </div>
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              <div className={styles.sharedTextStyle}>
                                ₹{row.jobPay}
                              </div>
                            </TableCell>

                            <TableCell className={styles.tableCell}>
                              <div className={styles.linkWithImage}>
                                <img
                                  src={PdfIcon}
                                  alt="PDF Icon"
                                  className={styles.icon}
                                />
                                <a href="#" className={styles.link}>
                                  {row.RecceReport}
                                </a>
                              </div>
                            </TableCell>

                            <TableCell>
                              <button className={styles.editButton}>
                                Edit
                              </button>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </AccordionDetails>
              {/* <BatchActions /> */}
            </Accordion>
          </Grid>
        ))
      )}
    </Grid>
  );
};

export default NotAccepted;
